import {
  SelectFormFieldSpecs,
  TextFormFieldSpecs,
} from 'modules/form-helpers/index';

import { bankRoutingMask } from 'utils/forms/masks';

import { bankRoutingRegExp } from 'utils/forms/regular-expressions';

import { isValidRoutingNumber } from 'utils/forms/validators';

export enum BankAccountType {
  Checking = 'Checking',
  Savings = 'Savings',
}

type FormFields = {
  accountNumber: TextFormFieldSpecs;
  accountType: SelectFormFieldSpecs;
  bankName: TextFormFieldSpecs;
  wireRoutingNumber: TextFormFieldSpecs;
};

export const formFields: FormFields = {
  accountNumber: {
    label: 'Wire Account Number',
    name: 'accountNumber',
    placeholder: 'Wire account number',
    validations: {
      required: true,
    },
  },
  accountType: {
    label: 'Account Type',
    name: 'accountType',
    options: Object.entries(BankAccountType).map(([value, label]) => {
      return { label, value };
    }),
    placeholder: 'Checking or Savings',
    validations: {
      required: true,
    },
  },
  bankName: {
    label: 'Bank Name',
    name: 'bankName',
    placeholder: 'Name',
    validations: {
      required: true,
    },
  },
  wireRoutingNumber: {
    label: 'Wire Routing Number',
    name: 'wireRoutingNumber',
    placeholder: '9 digit wire routing number',
    mask: bankRoutingMask,
    validations: {
      required: true,
      pattern: bankRoutingRegExp,
      validate: (value: string) =>
        isValidRoutingNumber(value) ||
        `${formFields.wireRoutingNumber.label} must be valid`,
    },
  },
};
